export const hasLoadingReceipe = (table, type) => {
  return (
    table.loadingReceipe !== undefined &&
    table.loadingReceipe[type] !== undefined &&
    table.loadingReceipe[type] === true
  );
};
